var alignment_rtlignore_default = {
  "alignLeft": "ja5Fp",
  "textWrapNowrap": "_7-uv9",
  "alignRight": "yAa1F",
  "alignCenter": "_0ieQi",
  "sizeFullWidth": "wh2f-",
  "renderedInTable": "PEIO1",
  "sizeOriginal": "_3kb2c",
  "sizeContent": "BQkBR",
  "sizeSmall": "VtNL-",
  "sizeSmallCenter": "MNc8O",
  "flex": "_20zTr",
  "LEFT": "Fxj77",
  "CENTER": "qQTX4",
  "RIGHT": "vkbeJ",
  "AUTO": "pqcPG",
  "JUSTIFY": "_0uV8u"
};
export {
  alignment_rtlignore_default as default
};
//# sourceMappingURL=alignment.rtlignore-scss.js.map
